import { axios } from '@/utils/request'

const api = {
  basicPrice: '/basicdata/basicPrice',
}

export function getBasicPriceList (parameter) {
  return axios({
    url: api.basicPrice + '/list',
    method: 'get',
    params: parameter
  })
}

export function getDetails (parameter) {
  return axios({
    url: `/basicdata/basicPrice/get/${parameter}`,
    method: 'get',
  })
}
//
// export function saveChannel (parameter) {
//   return axios({
//     url: api.info+(parameter.channelId == 0 ? '/save' : '/update'),
//     method: 'post',
//     data: parameter,
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     }
//   })
// }

export function remove (parameter) {
  return axios({
    url: api.basicPrice + '/remove',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//新建
export function save (parameter) {
  return axios({
    url: api.basicPrice + '/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//编辑
export function update (parameter) {
  return axios({
    url: api.basicPrice + '/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const channelExport = api.channel + '/export'
